var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnotations = function SvgAnnotations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.957 21.914C4.909 21.914 0 17.004 0 10.957S4.91 0 10.957 0s10.957 4.91 10.957 10.957-4.91 10.957-10.957 10.957M10.259 6.08a.735.735 0 0 1 1.407 0l1.794 5.36h.01c.516 0 .946.387 1.053.924l1.343 6.295a9.13 9.13 0 0 0 4.222-7.702 9.123 9.123 0 0 0-9.131-9.13 9.123 9.123 0 0 0-9.13 9.13 9.13 9.13 0 0 0 4.232 7.713L7.4 12.353c.108-.526.548-.913 1.053-.913h.01zm.698 14.008c1.29 0 2.514-.269 3.63-.752l-1.385-6.51h-4.48l-1.385 6.52a9.2 9.2 0 0 0 3.62.742"
  })));
};
export default SvgAnnotations;